import { v4 as uuidv4 } from 'uuid';
import { z } from 'zod';
import { zModifierType } from '../enums';
import { zText, zTextNullable } from '../primitives';

/** modifierGroups don't have a `displayIndex` and are instead sorted by the position they are
 * in the array `menuItem.modifierGroups`.
 */
export const modifierGroupSchema = z.object({
  defaultModifierUuid: z.string().nullable().default(null),
  displayName: z.string().nullable().default(null),
  isShared: z.boolean().default(true),
  modifierType: zModifierType.default('SIZE'),
  name: z.string(),
  qtyMax: z.number().default(1),
  qtyMin: z.number().default(1),
  uuid: z.string().default(() => uuidv4()),

  createdAt: z.number().optional(),
  updatedAt: z.number().optional(),
});
export type ModifierGroup = z.output<typeof modifierGroupSchema>;

/** Strict schema */
export const modifierGroupStrictSchema = modifierGroupSchema
  .extend({
    defaultModifierUuid: z.guid().nullable(),
    displayName: zTextNullable,
    name: zText,
    qtyMax: z.int().positive().max(99),
    qtyMin: z.int().nonnegative(),
    uuid: z.guid(),
  })
  /** Validate: qtyMin must be less than or equal to qtyMax */
  .refine((mg) => mg.qtyMin <= mg.qtyMax, {
    message: 'Minimum quantity must be less than or equal to maximum quantity',
    path: ['qtyMin'],
  });

/** Convex schema */
export const modifierGroupCvxSchema = modifierGroupSchema.safeExtend({
  createdAt: z.number(),
  updatedAt: z.number(),
});
export type ModifierGroupCvx = z.output<typeof modifierGroupCvxSchema>;
